import { CloseButtonProps, ModalCloseButton } from '@chakra-ui/react';
import React from 'react';

export const CmModalCloseButton: React.FC<CloseButtonProps> = ({ ...rest }) => {
  // @ts-ignore TS2590
  return <ModalCloseButton {...rest} />;
};
